<template>
  <v-data-table
    v-bind="$attrs"
    :options="options"
    @update:options="handleUpdateOptions"
    :server-items-length="totalItems"
    :items="items"
    :loading="loading"
    :page="page"
    hide-default-footer
    mobile-breakpoint="960"
  >
    <template v-slot:footer="{ props, on }">
      <v-data-footer
        v-bind="props"
        v-on="on"
        :items-per-page-options="itemsPerPageOptions"
      />
    </template>
    <template
      v-for="(_, name) in $scopedSlots"
      :slot="name"
      slot-scope="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </v-data-table>
</template>

<script>
export default {
  name: "core-table",
  props: {
    sortBy: {
      type: String,
      default: "id"
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 15
    },
    indexUrl: {
      type: String
    },
    itemsPerPageOptions: {
      type: Array,
      default: () => [5, 10, 15, -1]
    },
    queryParam: {
      type: String,
      default: "q"
    }
  },
  data: function() {
    let options = this.queryToOptions();

    return {
      options,
      items: [],
      totalItems: 0,
      page: 1,
      loading: false,
      filter: ""
    };
  },
  methods: {
    getRouteOptionsCode() {
      return this.$route.query[this.queryParam];
    },
    applyRouteOptionsCode(optionsCode) {
      if (this.getRouteOptionsCode() == optionsCode) {
        console.log("código igual");
        return;
      }

      this.$router.replace({
        query: {
          ...this.$route.query,
          [this.queryParam]: optionsCode
        }
      });
    },
    createOptionsCode(options) {
      const { page, itemsPerPage, sortBy, sortDesc, filter } = options;

      return btoa(
        JSON.stringify({
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          filter
        })
      );
    },
    handleUpdateOptions(options) {
      this.options = options;
      const optionsCode = this.createOptionsCode({
        ...this.options,
        ...options,
        filter: this.filter
      });

      this.applyRouteOptionsCode(optionsCode);
    },
    queryToOptions() {
      const initialOptions = {
        itemsPerPage: this.itemsPerPage,
        sortBy: [this.sortBy],
        page: 1,
        filter: "",
        sortDesc: [this.sortDesc]
      };

      const code = this.getRouteOptionsCode();
      if (!code) return initialOptions;

      const jsonData = atob(code);

      try {
        const data = JSON.parse(jsonData);

        return {
          ...this.options,
          ...data
        };
      } catch (error) {
        return initialOptions;
      }
    },
    getParams() {
      const { sortBy, sortDesc, page, itemsPerPage, filter } = {
        ...this.options,
        ...this.queryToOptions()
      };

      return {
        orderBy: sortBy ? sortBy[0] : "",
        sortDesc: sortDesc ? sortDesc[0] : "",
        page: parseInt(page),
        perPage: parseInt(itemsPerPage),
        filter
      };
    },
    handleFilter(filter) {
      this.filter = filter;

      this.handleUpdateOptions({
        ...this.options,
        page: 1
      });
    },
    async getItems() {
      const params = this.getParams();
      console.log("params", params);
      console.log("options", this.options);

      this.items = [];
      this.loading = true;
      const response = await this.$http.get(this.indexUrl, {
        params
      });

      const responseData = response.data;

      this.items = responseData.data;
      this.totalItems = responseData.total;
      this.loading = false;
      this.page = responseData.current_page;
    },
    refresh() {
      this.getItems();
    }
  },
  watch: {
    $route(to, from) {
      this.filter = this.getParams().filter || "";

      this.getItems();
    }
  },
  created() {
    this.filter = this.getParams().filter || "";

    if (this.getRouteOptionsCode()) this.getItems();
  }
};
</script>
